import axios from 'axios';
import {CONFIG, URLS,getAccessToken} from '../helpers/Common';


export const SURGEON = {
    login,
    logout,
    getPendingPatientsNarrative,
};

function getPendingPatientsNarrative(surgeon_id) {
    let data = new FormData();
    data.append('surgeon_id',surgeon_id);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
 }
 
function login(userData)
{
    let data = new FormData();
    data.append('email',userData.email);
    data.append('password',userData.password);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.login}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
function logout(userData)
{
    let data = new FormData();
    data.append('email',userData.email);
    data.append('password',userData.password);
    data.append('token',userData.token);
    let requestOptions = {
        method:'POST',
        data,
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        url:`${CONFIG.API_URL+URLS.logout}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}
